import React from 'react';

interface BletSnapshotsProps {
  detectionImage?: string;
  afterImage?: string;
  positionLabel?: string;
}

export function BletSnapshots({ detectionImage, afterImage, positionLabel }: BletSnapshotsProps) {
  // Working placeholder images - using picsum for reliable images
  const placeholderDetection = 'https://static.thenounproject.com/png/1211233-200.png';
  const placeholderAfter = 'https://static.thenounproject.com/png/1211233-200.png';

  return (
    <div className="flex gap-2 flex-1 min-h-0 overflow-hidden p-2">
      <div className="w-1/2 relative">
        <div className="absolute top-2 left-2 z-10 flex items-center gap-2">
          <span className="bg-black/70 text-white px-2 py-1 rounded text-sm font-medium">Detection</span>
          {positionLabel && <span className="bg-black/70 text-white px-2 py-1 rounded text-sm">{positionLabel}</span>}
        </div>
        <div className="h-full min-h-[300px] border-2 border-gray-600 rounded-lg overflow-hidden flex items-center justify-center bg-gray-900">
          <img src={detectionImage || placeholderDetection} className="w-full h-full object-cover" alt="Detection" />
        </div>
      </div>
      <div className="w-1/2 relative">
        <div className="absolute top-2 left-2 z-10 flex items-center gap-2">
          <span className="bg-black/70 text-white px-2 py-1 rounded text-sm font-medium">After</span>
          {positionLabel && <span className="bg-black/70 text-white px-2 py-1 rounded text-sm">{positionLabel}</span>}
        </div>
        <div className="h-full min-h-[300px] border-2 border-gray-600 rounded-lg overflow-hidden flex items-center justify-center bg-gray-900">
          <img src={afterImage || placeholderAfter} className="w-full h-full object-cover" alt="After" />
        </div>
      </div>
    </div>
  );
}
